import { SymbolIcon, TriggerButton, useResizableTabPanelsContext } from "widgets";

export const GenomeViewerStatusBarActions = () => {
  const { isOpen, togglePanel } = useResizableTabPanelsContext();

  return (
    <TriggerButton
      onPress={() => {
        togglePanel();
      }}
      label="Toggle Status Bar"
      icon={<SymbolIcon icon={isOpen ? "bottom_panel_close" : "bottom_panel_open"} filled={isOpen} />}
      data-testid="toggle-status-bar"
    />
  );
};
